import React from 'react';
import {connect} from 'react-redux';

import Portal from '../../../general/components/Portal';

import Toggle from './Toggle';
import Legend from './Legend';

const LegendArea = ({panelOpen}) => (
    <Portal container="legend-area">
        <Toggle panelOpen={panelOpen} />
        <Legend show={panelOpen === 'legend'} />
    </Portal>
);

const mapStateToProps = ({panelOpen}) => ({panelOpen});

export default connect(mapStateToProps)(LegendArea);
